import React from "react";

export default function DirectionMapIcon({ color, angle, ...props }) {
  return (
    <div
      style={{
        transform: `rotate(${angle}deg)`,
        background: "rgb(127,255,0, 0.3)",
        borderRadius: "50%",
        width: "35px",
        height: "35px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      {...props}
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <polygon points="3,11 22,2 13,21 11,13 3,11" />
      </svg>
    </div>
  );
}
